export const SIGNUP_INITIATED_EVENT = 'sui'
